<p>fx-editor works!</p>
